import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h1: {
      marginTop: "2rem",
      textAlign: "center",
      fontSize: "4rem",
      "@media (min-width:600px)": {
        fontSize: "4rem",
      },
      "@media (min-width:960px)": {
        fontSize: "4rem",
      },
      "@media (min-width:1280px)": {
        fontSize: "5rem",
      },
      fontWeight: "bold",
      fontFamily: "DotGothic16",
    },
    h3: {
      fontFamily: "DotGothic16",
    },
    h4: {
      fontFamily: "DotGothic16",
    },
  },
  palette: {
    primary: {
      main: "#222222",
      light: "#008CFF",
      dark: "#004C99",
    },
    secondary: {
      main: "#A0A0A0",
      light: "#E0E0E0",
      dark: "#808080",
    },
    error: {
      main: red.A400,
    },
    background: {
      paper: "#f6f6f6",
      default: "#ffffff",
    },
    text: {
      primary: "#0066CC",
      secondary: "#A0A0A0",
    },
  },
});

export default theme;
